import { useMemo } from "react";
import { useSelector } from "react-redux";

/** Active teams for the current company. */
export const UseTeams = () => {
  const list = useSelector((state) => state.teamsReducer?.list);
  return Array.isArray(list) ? list : [];
};

/** Member count per team name. */
export const UseTeamCounts = () => {
  const counts = useSelector((state) => state.teamsReducer?.counts);
  return counts && typeof counts === "object" ? counts : {};
};

/** Lookup a team object by name (returns undefined if not found). */
export const UseTeamByName = (name) => {
  const list = UseTeams();
  return useMemo(
    () => (name ? list.find((t) => t.name === name) : undefined),
    [list, name],
  );
};

/** Map of teamName -> color, for quick palette resolution on the TV. */
export const UseTeamColorMap = () => {
  const list = UseTeams();
  return useMemo(() => {
    const map = {};
    list.forEach((t) => {
      if (t?.name && t?.color) map[t.name] = t.color;
    });
    return map;
  }, [list]);
};

export const UseTeamsLoading = () =>
  useSelector((state) => Boolean(state.teamsReducer?.loading));

export const UseTeamsSaving = () =>
  useSelector((state) => Boolean(state.teamsReducer?.saving));

export const UseTeamsError = () =>
  useSelector((state) => state.teamsReducer?.error || null);
